import config from '../../config';
import { callApiWithToken } from './base';

export const fetchTags = async (token: string, type: string) =>
  callApiWithToken(`${config.urls.tags}?type=${type}`, token, 'GET');
